import { FINISHED_SETTLEMENTS_URL } from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IApiResponse } from "../../models";

interface CashoutProps {
  contractId?: string;
  referenceTransactionId?: string;
  /** Settlement-date bounds, pre-formatted as `YYYY-MM-DD HH:mm`. */
  settledAtFrom?: string;
  settledAtTo?: string;
  page: number;
  size: number;
  organizationCode?: string;
}

const defaultProvide = async () => await getToken();

/** `settledAt` bounds as query params; both are optional and independent. */
const settledAtParams = (from?: string, to?: string): string =>
  `${from ? `&settledAtFrom=${encodeURIComponent(from)}` : ""}${
    to ? `&settledAtTo=${encodeURIComponent(to)}` : ""
  }`;

export const getPendingCashouts = ({
  contractId = "",
  referenceTransactionId = "",
  settledAtFrom = "",
  settledAtTo = "",
  page = 0,
  size = 10,
  organizationCode,
}: CashoutProps): Promise<IApiResponse> => {
  let searchKeyWord = "";
  if (contractId) searchKeyWord = contractId?.replace("+", "%2B");
  const url = `${FINISHED_SETTLEMENTS_URL}?status=CASH_OUT_APPROVED,PARTIALLY_RELEASED&type=QUICK_TRANSACTION,MILESTONE_CONTRACT,BROKERAGE_CONTRACT&page=${page}&size=${size}${
    contractId ? `&searchKeyWord=${searchKeyWord}` : ""
  }${
    referenceTransactionId
      ? `&referenceTransactionId=${referenceTransactionId}`
      : ""
  }${
    organizationCode ? `&organizationCode=${organizationCode}` : ""
  }${settledAtParams(settledAtFrom, settledAtTo)}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};

export const getFinishedCashouts = ({
  contractId = "",
  referenceTransactionId = "",
  settledAtFrom = "",
  settledAtTo = "",
  page = 0,
  size = 10,
  organizationCode,
}: CashoutProps): Promise<IApiResponse> => {
  let searchKeyWord = "";
  if (contractId) searchKeyWord = contractId?.replace("+", "%2B");
  const url = `${FINISHED_SETTLEMENTS_URL}?status=COMPLETED,EXCEPTIONAL_COMPLETED&type=QUICK_TRANSACTION&page=${page}&size=${size}${
    contractId ? `&searchKeyWord=${searchKeyWord}` : ""
  }${
    referenceTransactionId
      ? `&referenceTransactionId=${referenceTransactionId}`
      : ""
  }${
    organizationCode ? `&organizationCode=${organizationCode}` : ""
  }${settledAtParams(settledAtFrom, settledAtTo)}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};
